export const EXTENDED_CONFIG_NAME = "extendedConfig";
